import {createSlice}  from '@reduxjs/toolkit';

const buyFlowMapSlice = createSlice({
    name: 'map',
    initialState: { 
        mapObj: null,
        address: null,
        currentAddress: null,
        street: '',
        city: '',
        state: '',
        zip: '',
        center: null,
        isLoaded: false,
        mapType: 'satellite',
        zoom: 20,
        lawnMeasurementCoordinates: null,
        initialLawnMeasurementCoordinates: null,
        totalAreaSqftValue: 0,
        initialTotalAreaSqftValue: 0,
        lawnAreas: [],
        measurementSource:"",
        olympusData: null,
        branchNumber: false,
        manualMeasurementCoordinates: null,
        getNbsPolygonData: {},
        measurementType: "Auto",
        mmYards: "",
        currentZoomVal: 20
    },
    reducers: {
      storeMapObject: (state, action) => {
        
        state.mapObj = action.payload;
      },
      setZoom: (state, action) => {
        
        state.zoom = action.payload;
      },
      setMapType: (state, action) => {
        
        state.mapType = action.payload;
      },
      setMapAddress: (state, action) => {
        
        state.address = action.payload;
      },
      saveAddressSection : (state, action) => {
        
        state.street = action.payload.street;
        state.city = action.payload.city;
        state.state = action.payload.state;
        state.zip = action.payload.zip;

      },
      setMapCurrentAddress: (state, action) => {
        
        state.currentAddress = action.payload;
      },
      setCenter: (state, action) => {
        
        state.center = action.payload;
      },
      updateMapLoadStatus: (state, action) => {
        
        state.isLoaded = action.payload;
      },
      setLawnMeasurementMapCoordinates: (state, action) => {
        
        state.lawnMeasurementCoordinates = action.payload;
      },
      setManualMeasurementMapCoordinates: (state, action) => {
        state.manualMeasurementCoordinates = action.payload;
      },
      setMMYards: (state, action) => {
        state.mmYards = action.payload;
      },
      setGetNbsPolygonData: (state, action) => {
        
        state.getNbsPolygonData = action.payload;
      },
      setInitialTotalAreaSqftValue: (state, action) => {
        
        state.initialTotalAreaSqftValue = action.payload;
      },
      setTotalAreaSqftValue: (state, action) => {
        
        state.totalAreaSqftValue = action.payload;
      },
      setLawnAreas: (state, action) => {
        
        state.lawnAreas = action.payload;
      },
      setMeasurementSource: (state, action) => {
        
        state.measurementSource = action.payload;
      },
      setOlympusData: (state, action) => {
        
        state.olympusData = action.payload;
      },
      setBranchNumber: (state, action) => {
        
        state.branchNumber = action.payload;
      },
      setMeasurementType: (state, action) => {
        state.measurementType = action.payload;
      },
      setCurrentZoomVal: (state, action) => {
        state.currentZoomVal = action.payload;
      }
    }
  });
  
  export const { storeMapObject, setMapAddress, setMapCurrentAddress, setCenter, updateMapLoadStatus, setLawnMeasurementMapCoordinates, setZoom, setMapType, setInitialTotalAreaSqftValue, setTotalAreaSqftValue, setLawnAreas, setMeasurementSource, setBranchNumber, setOlympusData, saveAddressSection, setGetNbsPolygonData, setManualMeasurementMapCoordinates, setMeasurementType, setMMYards, setCurrentZoomVal } = buyFlowMapSlice.actions;
  export default buyFlowMapSlice.reducer;